import React, {  useContext, useState, useCallback, useEffect } from 'react';
import { Loader, ModalBody, ModalFooter, ModalHeader, ModalNext } from '@jutro/components';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';

import { BreakpointTrackerContext } from '@jutro/layout';
import { Button } from '@jutro/legacy/components';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
// import { CustomQuoteService } from 'twia-capability-quoteandbind-residential';
import _ from 'lodash';

// import PrintDocumentUtils from 'ent-capability-quoteandbind-common-react/util/PrintDocumentUtils.js';
import metadata from './PrintDocumentErrorPopup.metadata.json5';
import styles from './PrintDocumentErrorPopup.module.scss';
import messages from '../QuotePage.messages';

function PrintDocumentErrorPopup(props) {
    const {
        submissionVM,
        setIsPrinting,
        isOpen,
        onResolve,
        onAfterClose,
    } = props;

    const breakpoint = useContext(BreakpointTrackerContext);
    const [isLoading, /* setIsLoading */] = useState(false);

     const translator = useTranslator();

     useEffect(() => {
        setIsPrinting(true);
     },[setIsPrinting])
    
   
    const handleDocumentClose = useCallback(() =>{
        setIsPrinting(false);       
        onResolve();
    }, [onResolve, setIsPrinting])

    

    const overrideProps = {
        '@field': {
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        printDocumentBodyId: {
            content: translator(messages.documentErrorMessage)
        }
    };

    const resolvers = {
        resolveCallbackMap: {
        },
        resolveClassNameMap: styles
    };

    return (
        <ModalNext isOpen={isOpen} onAfterClose={onAfterClose} className={styles.infoBg} >        
            <ModalHeader title={translator(messages.documentErrorTitle)}  />
            <ModalBody>
                <Loader loaded={!isLoading}>   
                    <ViewModelForm
                        uiProps={metadata.componentContent}
                        model={submissionVM}
                        overrideProps={overrideProps}
                        classNameMap={resolvers.resolveClassNameMap}
                        callbackMap={resolvers.resolveCallbackMap}
                    />
                </Loader>
            </ModalBody>
            <ModalFooter>
                <Button onClick={handleDocumentClose} type="outlined"> {translator(messages.documentCloseButton)} </Button>
            </ModalFooter>
        </ModalNext>
    )
}

PrintDocumentErrorPopup.propTypes = {
    isOpen: PropTypes.bool,
    onResolve: PropTypes.func,
    onReject: PropTypes.func,
    onAfterClose: PropTypes.func
};

PrintDocumentErrorPopup.defaultProps = {
    isOpen: false,
    onResolve: _.noop,
    onReject: _.noop,
     onAfterClose: _.noop
};

export default PrintDocumentErrorPopup;